import moment from 'moment';
import datePicker from "vue-bootstrap-datetimepicker";

Vue.component('powerhour', {
    components: {
        datePicker
    },

    data () {
        return {
            filters: {
                from: moment().startOf('today').format("DD-MM-YYYY"),
                to: moment().endOf('year').format("DD-MM-YYYY"),
            },

            createForm: $.extend(true, new Form({
                data: {
                    start: '',
                    finish: ''
                }
            }), {}),

            editForm: $.extend(true, new Form({
                data: {
                    start: '',
                    finish: ''
                }
            }), {}),

            tpFilterOptions: {
                format: 'DD-MM-YYYY',
            },

            tpOptions: {
                format: 'DD-MM-YYYY HH:mm',
            },

            loading: false,

            sessions: [],

            deleteId: null,

            editId: null,

            viewSessionId: null
        };
    },

    mounted () {
        this.getSessions();

        $('#delete').on('hidden.bs.modal', () => {
            this.deleteId = null;
        });

        $('#edit').on('hidden.bs.modal', () => {
            this.editForm.resetForm();

            this.editId = null;
        });
    },

    methods: {
        setFinishValue (v) {
            if (v.date !== false) {
                let finish = v.date.clone();

                this.createForm.data.finish = finish.add(1, 'hour').format('DD-MM-YYYY HH:mm');
            }
        },

        getSessions () {
            this.loading = true;

            axios.get('/api/power-hour', {
                params: {
                    ...this.filters
                }
            }).then((response) => {
                this.loading = false;
                this.sessions = response.data;
            });
        },

        store () {
            Http.post('/api/power-hour/create/', this.createForm).then(response => {
                this.getSessions();

                this.createForm.resetForm();

                $('#create').modal('hide');
            });
        },

        deleteSession (id) {
            this.deleteId = id;

            $('#delete').modal('show');
        },

        doDelete () {
            axios.post('/api/power-hour/delete/' + this.deleteId).then(response => {
                this.getSessions();

                $('#delete').modal('hide');
            });
        },

        editSession (session) {
            this.editId = session.id;

            this.editForm.data.start = moment(session.start).format("DD-MM-YY HH:mm");
            this.editForm.data.finish = moment(session.finish).format("DD-MM-YY HH:mm");

            $('#edit').modal('show');
        },

        update () {
            Http.post('/api/power-hour/update/' + this.editId, this.editForm).then(response => {
                this.getSessions();

                $('#edit').modal('hide');
            });
        },

        viewResults (session) {
            $('#view-results').modal('show');

            this.viewSessionId = session.id;
        }
    },

    filters: {
        phDate (value) {
            return moment(value).format("DD/MM/YYYY HH:mm");
        }
    }
});